import React, {Component} from "react";
import {Switch, Route} from "react-router-dom";
import Index from "./index";
import Edit from "./edit";

export default class Base extends Component {
    render() {
        return (
                <Switch>
                    <Route exact path="/interfacetexts" component={Index}/>
                    <Route path="/interfacetexts/create" component={Edit}/>
                    <Route path="/interfacetexts/:id" component={Edit}/>
                </Switch>
        )
    }
}
